// Usage events for Google Analytics, pushed to Google Tag Manager's dataLayer (container GTM-P7PDD9RF).
// The page promises that titles, descriptions and files never leave the browser, so events carry
// only statuses, counts and choices: never anything the visitor typed or uploaded.

export type UsageEvent = 'snippet_check' | 'bulk_check' | 'bulk_export' | 'copy_as_text';

export interface EventParams {
  title_status?: string;
  description_status?: string;
  /** Warning codes, sorted and comma-joined, or "none". */
  warnings?: string;
  device_count?: number;
  row_count?: number;
  /** Where bulk rows came from: file, paste, sample or rerun. */
  source?: string;
  /** completed or stopped. */
  outcome?: string;
  export_format?: string;
  /** Profile id, e.g. android-360. */
  device?: string;
}

// Tag Manager keeps every key ever pushed, so each event clears the other events' parameters.
const CLEARED: Record<keyof EventParams, undefined> = {
  title_status: undefined, description_status: undefined, warnings: undefined, device_count: undefined,
  row_count: undefined, source: undefined, outcome: undefined, export_format: undefined, device: undefined,
};

export function track(event: UsageEvent, params: EventParams): void {
  const w = window as Window & { dataLayer?: object[] };
  (w.dataLayer ??= []).push({ event, ...CLEARED, ...params });
}
